import React, { useState } from 'react'
import { Swiper, SwiperSlide } from 'swiper/react'
import { Autoplay, Navigation, Pagination } from 'swiper/modules'
import 'swiper/css'
import 'swiper/css/navigation'
import 'swiper/css/pagination'
import { ChevronDown, Tag } from 'lucide-react'

const coupons = [
    {
        id: 1,
        discount: '₹ 125 OFF',
        name: 'FLAT 125',
        description: 'Lorem Ipsum is simply dummy text of the printing.'
    },
    {
        id: 2,
        discount: '₹ 250 OFF',
        name: 'FLAT 250',
        description: 'Lorem Ipsum is simply dummy text of the printing.'
    },
    {
        id: 3,
        discount: '₹ 500 OFF',
        name: 'FLAT 500',
        description: 'Lorem Ipsum is simply dummy text of the printing.'
    }
]
const CouponComponent = () => {
    const [couponOpen, setCouponOpen] = useState(false)
    return (
        <>
            <div className="div-for-the-coupons">
                <div className="coupons-box-here">

                    <div
                        className="coupon-accordion-here"
                        onClick={() => setCouponOpen(!couponOpen)}
                        style={{ cursor: 'pointer' }}>
                        <button className="coupons-show-btn">
                            <Tag className="coupon-tag" />
                            Apply Coupon
                        </button>

                        <ChevronDown
                            className={`transition-transform duration-300 ${couponOpen ? 'rotate-180' : ''
                                }`}
                        />
                    </div>

                    {couponOpen && (
                        <div className="coupon-accordion-content">

                            <div className="coupon-items-here coupons-swiper-slider">
                                <Swiper
                                    modules={[Navigation, Pagination, Autoplay]}
                                    spaceBetween={20}
                                    slidesPerView={1.2}
                                    autoplay={true}
                                    navigation={false}
                                    pagination={{ clickable: true }}
                                    breakpoints={{
                                        640: { slidesPerView: 1.5 },
                                        768: { slidesPerView: 1.5 },
                                        1024: { slidesPerView: 2 }
                                    }}
                                >
                                    {coupons.map((coupon) => (
                                        <SwiperSlide key={coupon.id}>
                                            <div className="apply-coupon-box" style={{ width: "100%" }}>
                                                <div className="vertical-text-data">
                                                    <p>{coupon.discount}</p>
                                                </div>

                                                <div className="coupon-right-data">
                                                    <p className="coupon-name">{coupon.name}</p>
                                                    <p className="coupon-decsriptionn">
                                                        {coupon.description}
                                                    </p>
                                                    <a href="#" className="apply-coupon-btnn">
                                                        APPLY
                                                    </a>
                                                </div>
                                            </div>
                                        </SwiperSlide>
                                    ))}
                                </Swiper>
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </>
    )
}

export default CouponComponent